import { render } from "./ChatTemplates.vue?vue&type=template&id=0b3c7dc8&scoped=true"
import script from "./ChatTemplates.vue?vue&type=script&lang=js"
export * from "./ChatTemplates.vue?vue&type=script&lang=js"

import "./ChatTemplates.vue?vue&type=style&index=0&id=0b3c7dc8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3c7dc8"],['__file',"webpack-assets/vue/templates/chat/parts/ChatTemplates.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b3c7dc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b3c7dc8', __exports__)) {
    api.reload('0b3c7dc8', __exports__)
  }
  
  module.hot.accept("./ChatTemplates.vue?vue&type=template&id=0b3c7dc8&scoped=true", () => {
    api.rerender('0b3c7dc8', render)
  })

}


export default __exports__